<dx-popup
    #manageVendorAccountPopup
    minWidth="150px"
    minHeight="150px"
    width="60%"
    height="75%"
    position="right"
    title="Vendor Account Information"
    [showCloseButton]="true"
    [shading]="false"
    [showTitle]="true"
    [dragEnabled]="true"
    [resizeEnabled]="true"
    [closeOnOutsideClick]="false"
    [(visible)]="visible"
    (onShown)="onVendorAccountShown()"
    (onHidden)="onVendorAccountHide()"
>
    <div *dxTemplate="let data of 'content'">
        <dx-box width="100%" height="100%" direction="col" class="cc-account-edit-box account-edit-box">
            <dxi-item baseSize="auto">
                <div *dxTemplate class="property-container">
                    <dx-box width="100%" height="100%" direction="row">
                        <dxi-item baseSize="auto">
                            <div *dxTemplate class="row-container">
                                <div class="row-label">Vendor:</div>
                                <app-hyperlink-creator
                                    mode="hyperlinkOnly"
                                    actionCode="VENDOR_MANAGEMENT"
                                    [displayText]="vendorName"
                                    (onLinkClick)="onVendorNameClick()"
                                ></app-hyperlink-creator>
                            </div>
                        </dxi-item>
                        <dxi-item [ratio]="1" *ngIf="isInternalUser">
                            <div *dxTemplate class="button-container">
                                <dx-button
                                    icon="plus"
                                    type="default"
                                    text="Add New Vendor Account"
                                    (onClick)="onAddNewVendorAccount()"
                                ></dx-button>
                            </div>
                        </dxi-item>
                    </dx-box>
                </div>
            </dxi-item>

            <dxi-item [ratio]="1">
                <div *dxTemplate>
                    <div class="no-data-container" *ngIf="!hasSourceData">There are no accounts for Vendor.</div>
                    <div *ngIf="hasSourceData" class="grid-container">
                        <cc-data-grid-features
                            [stateConfig]="{ storageKey: 'MANAGE_VENDOR_ACCOUNT_GRID' }"
                            [dataSource]="manageVendorAccountsSource.vendorAccounts"
                        >
                            <dx-data-grid
                                width="100%"
                                height="100%"
                                appHasInternalUserColumns
                                [dataSource]="manageVendorAccountsSource.vendorAccounts"
                            >
                                <dxi-column
                                    name="InternalActions"
                                    type="buttons"
                                    alignment="center"
                                    caption="Action"
                                    [width]="110"
                                    [showInColumnChooser]="false"
                                >
                                    <dxi-button template="template">
                                        <div *dxTemplate="let t of 'template'">
                                            <dx-button
                                                icon="runner"
                                                class="icon-button-content"
                                                type="normal"
                                                text="Action"
                                                (onClick)="onActionClick(t.data)"
                                            ></dx-button>
                                        </div>
                                    </dxi-button>
                                </dxi-column>

                                <dxi-column
                                    dataField="accountNumber"
                                    caption="Account #"
                                    dataType="string"
                                ></dxi-column>
                                <dxi-column
                                    dataField="description"
                                    caption="Description"
                                    dataType="string"
                                ></dxi-column>
                                <dxi-column
                                    dataField="draftBankAccount"
                                    caption="Draft Bank Account Name"
                                    dataType="string"
                                ></dxi-column>
                                <dxi-column
                                    dataField="active"
                                    caption="Active"
                                    dataType="boolean"
                                    alignment="center"
                                    cellTemplate="activeCellTemplate"
                                ></dxi-column>
                                <dxi-column
                                    dataField="eftActive"
                                    caption="EFT"
                                    dataType="boolean"
                                    alignment="center"
                                    cellTemplate="eftCellTemplate"
                                ></dxi-column>
                                <dxi-column
                                    name="InternalLogs"
                                    caption="Log"
                                    alignment="center"
                                    cellTemplate="logCellTemplate"
                                ></dxi-column>
                                <dxi-column
                                    name="InternalNotes"
                                    caption="Notes"
                                    alignment="center"
                                    cellTemplate="notesCellTemplate"
                                ></dxi-column>

                                <div *dxTemplate="let d of 'eftCellTemplate'">
                                    <div *ngIf="d.data.eftActive">
                                        <i class="cc-1-5x cc-icon-check" [ngClass]="iconCheck"></i>
                                    </div>
                                </div>

                                <div *dxTemplate="let d of 'activeCellTemplate'">
                                    <div *ngIf="d.data.active">
                                        <i class="cc-1-5x cc-icon-check" [ngClass]="iconCheck"></i>
                                    </div>
                                </div>

                                <div *dxTemplate="let a of 'logCellTemplate'">
                                    <i
                                        class="cc-1-5x icon-data-content dx-theme-accent-as-text-color"
                                        [ngClass]="iconHistory"
                                        (click)="onLogClick(a.data)"
                                    ></i>
                                </div>

                                <div *dxTemplate="let d of 'notesCellTemplate'">
                                    <div *ngIf="d.data.hasNotes">
                                        <i
                                            class="cc-1-5x icon-data-content cc-icon-check"
                                            [ngClass]="iconNotes"
                                            (click)="onAccountEditNotesClick(d.data)"
                                        ></i>
                                    </div>

                                    <div *ngIf="!d.data.hasNotes">
                                        <i
                                            class="cc-1-5x icon-data-content dx-theme-accent-as-text-color"
                                            [ngClass]="iconEmptyNotes"
                                            (click)="onAccountEditNotesClick(d.data)"
                                        ></i>
                                    </div>
                                </div>
                            </dx-data-grid>
                        </cc-data-grid-features>
                    </div>
                </div>
            </dxi-item>
            <dxi-item baseSize="auto">
                <div *dxTemplate>
                    <dx-toolbar width="100%">
                        <dxi-item location="before">
                            <div *dxTemplate>
                                <dx-button
                                    type="default"
                                    text="Close"
                                    [icon]="iconClose"
                                    (onClick)="onVendorAccountHide()"
                                ></dx-button>
                            </div>
                        </dxi-item>
                    </dx-toolbar>
                </div>
            </dxi-item>
        </dx-box>
    </div>
</dx-popup>

<app-vendor-account-history
    #vendorAccountHistory
    *ngIf="showHistoryPopUp"
    [visible]="showHistoryPopUp"
    [communityId]="communityId"
    [communityName]="communityName"
    [vendorName]="vendorName"
    [associationVendorId]="associationVendorId"
    [vendorAccountId]="selectedVendorAccount.id"
    [vendorAccountNumber]="selectedVendorAccount.accountNumber"
    (vendorAccountHistoryClose)="onVendorAccountHistoryClose()"
></app-vendor-account-history>

<app-vendor-account-notes
    #vendorAccountNotes
    *ngIf="showNotesPopUp"
    id="vendorAccountNotes"
    [communityId]="communityId"
    [hasNotes]="selectedVendorAccount.hasNotes"
    [associationVendorId]="selectedVendorAccount.associationVendorId"
    [vendorAccountId]="selectedVendorAccount.id"
    [accountNumber]="selectedVendorAccount.accountNumber"
    (vendorAccountNotesClose)="onVendorAccountNotesClose($event)"
></app-vendor-account-notes>
